(function() {
	'use strict';

	angular.module('exportWarehouseApp').factory('StockOutUsedCancelService',
			StockOutUsedCancelService);

	StockOutUsedCancelService.$inject = [ '$resource', '$http', 'GLOBAL_URL' ];

	function StockOutUsedCancelService($resource, $http, GLOBAL_URL) {
		return $resource(GLOBAL_URL + 'api/stockOutUsedCancel/:uri', {
			uri : '@uri'
		}, {
			'postList' : {
				method : 'POST',
				isArray : true
			},
			'post' : {
				method : 'POST'
			},
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET'
			},
			'returnValue': {
                method: 'GET',
                transformResponse: [function (data) {
                    return  { response: data };
                }],
                transformResponseError: function(error){
                	if(error.status === 0){
                		alert('There is a problem connecting to the server. Is the server probably down?!');
                	}
                	 return $q.reject(error);
                }
            }
		});
	}
})();
